// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"Related_dropdownMenu__HCcKj","itemNav":"Related_itemNav__hKGix","navigationMenu":"Related_navigationMenu__uizJx","navigationItem":"Related_navigationItem___ar_1"};